import { createScheduleComponent } from '@play-co/components';

/** Campaign window (exclusive end) and destination for every in-game CTA. */
export const stickerCampaign = {
  start: '2026-10-13T11:00:00+09:00',
  end: '2026-11-10T00:00:00+09:00',
  downloadUrl: 'https://line.me/S/sticker/37826?utm_source=lad_external_1',
} as const;

/** Five campaign weeks, including the shortened opening and closing windows. */
export const stickerCampaignSchedule = createScheduleComponent(
  stickerCampaign.start,
  'Asia/Tokyo',
  {
    once: [
      { at: stickerCampaign.start, duration: { days: 4, hours: 13 } },
      { at: '2026-10-18T00:00:00+09:00', duration: { days: 7 } },
      { at: '2026-10-25T00:00:00+09:00', duration: { days: 7 } },
      { at: '2026-11-01T00:00:00+09:00', duration: { days: 7 } },
      { at: '2026-11-08T00:00:00+09:00', duration: { days: 2 } },
    ],
  },
  stickerCampaign.end,
);
